export const WELCOME_BACK = 'Welcome back,';
export const WELCOME_TO_MANTA_CARES = 'Welcome to Manta Cares,';
export const GET_STARTED = "Let's get started!";
export const HOME_DIALOG_CONTENT =
    'We are so sorry you’re dealing with cancer. Our team has been there, so we’ve created the most comprehensive self-advocacy toolkit to help you understand and manage cancer.';
export const HOME_PAGE_SUB_TITLE =
    'We are here to help you navigate the cancer experience by finding the right information and resources at the right time. If you ever need help, click on the Manta Ray icon in the bottom right of your screen for extra guidance.';

// Map Feature texts
export const MY_MAP = 'My Map';
export const MAP_TOUR_CONTENT =
    'This is the **My Map** section. A map is assigned for your specific disease. It is a step-by-step map from diagnosis through survivorship created by world class oncologists and survivors. It provides you questions for your medical team, and resources for each part of the cancer experience.';
export const MY_MAP_NOT_AVAILABLE_DESCRIPTION = `Our disease-specific maps will show you all of the paths you might face during the cancer experience. They also give you information and point you to resources at each "map station" or decision point along the way.`;
export const MY_MAP_DESCRIPTION =
    'Maps cover diagnosis, treatment options, and support you need to manage living with the disease. Make decisions. Gain support. Get educated.';
export const MAP_AVAILABLE = 'Map Available';
export const EXPLORE_MAP_LABEL = 'Explore My Map';
export const MAP_ASSIGNMENT_HELPER_TEXT = 'Based on the provided information we have assigned this map:';
export const NEED_DIFFERENT_MAP = 'If you need a different map, please reach out to us at:';
export const MAP_NOT_AVAILABLE_TITLE = 'Manta Maps make navigating the cancer experience a little easier.';
export const MAP_NOT_AVAILABLE_HELPER_TEXT =
    "Our team, made up of cancer survivors and oncologists, created Manta Maps to guide you step-by-step through the entire cancer experience, personalized to the type of cancer you're facing.";
export const MAP_ASSIGNMENT_IN_PROGRESS = 'Map Assignment In Progress';
export const NOTIFIED_WHEN_MAP_ASSIGNED = 'You will be notified when a map has been assigned.';
export const MAP_IN_PROGRESS_CONTACT_TEXT = 'In the meantime if you have any questions, please reach out to us at';

// Guide Feature texts
export const MY_GUIDES = 'My Guides';
export const GUIDES_TOUR_CONTENT =
    'In this **My Guides** section, find (human!) support for additional expertise and guidance to help you through the cancer experience.';
export const MY_GUIDES_DESCRIPTION = 'We have created a hub of (human!) guides that you can search to find additional support.';
export const SEE_ALL_GUIDE = 'See All Guide';

// Gear Feature texts
export const MY_GEAR = 'My Gear';
export const MY_GEAR_DESCRIPTION =
    'Stay organized with our evidence-based templates and tools. You can personalize each of them for your specific situation.';
export const GEAR_TOUR_CONTENT =
    'In **My Gear**, discover tools and templates to organize the cancer experience. There are tools to manage appointments, track medications, nutrition and symptoms.';
export const APPOINTMENT_TITLE = 'Appointment Notebook';
export const APPOINTMENT_DESCRIPTION = 'Keep track of and prepare for appointments, list questions, take notes, and stay organized.';
export const GO_TO_APPOINTMENTS = 'Go to Appointments';
export const SYMPTOM_TRACKER_TITLE = 'Symptom Tracker';
export const SYMPTOM_TRACKER_DESCRIPTION = 'Easily log symptoms and side-effects. Track patterns and improve quality of life.';
export const GO_TO_SYMPTOMS = 'Go to Symptoms';
export const MEDICATION_MANAGEMENT_TITLE = 'Medication Management';
export const MEDICATION_MANAGEMENT_DESCRIPTION =
    'Stay on top of medications – track doses, receive timely reminders, and never miss a refill.';
export const GO_TO_MEDICATIONS = 'Go to Medications';
export const ALL_GEAR_TITLE = 'All Gear';
export const ALL_GEAR_DESCRIPTION = 'Explore our other tools designed to help manage cancer more effectively.';
export const SEE_ALL_GEAR = 'See All Gear';
export const ACTIVATE = 'Activate';
export const HOME_TOUR_CONFIRMATION = 'Would you like to take a quick dashboard tour?';
export const HOME_TOUR_RESUME_CONFIRMATION = 'Would you like to continue with the dashboard tour?';
